export const getLocations = async (keyword) => {
  const url = 'https://www.routerunnersautotransport.com/zip-search-gm.php';
  const data = new URLSearchParams();
  data.append('keyword', keyword);
  const response = await fetch(url, {
    method: 'post',
    body: data
  });
  const body = await response.json();
  let locations = [];
  if (body) {
    locations = body
                  .map((obj) => {
                    let { zip } = obj;
                      if (
                          typeof obj.zip === 'string'
                          && obj.zip.length === 6
                          && obj.zip.charAt(0) === '0'
                      ) {
                        zip = obj.zip.substring(1);
                      }
                    return { ...obj, zip };
                  });
  }
  return locations;
};

export const getMake = async (year) => {
  const url = 'https://www.routerunnersautotransport.com/make-checker-gm.php';
  const data = new URLSearchParams();
  data.append('a', year);
  data.append('is_ajax', 1);
  const response = await fetch(url, {
    method: 'post',
    body: data
  });
  const body = await response.text();

  return body;
};

export const getModel = async (year, make) => {
  const url = 'https://www.routerunnersautotransport.com/model-checker-gm.php';
  const data = new URLSearchParams();
  data.append('a', year);
  data.append('b', make);
  data.append('is_ajax', 1);
  const response = await fetch(url, {
    method: 'post',
    body: data
  });
  const body = await response.text();

  return body;
};
